export default {
    ProductDetail: () => import("./product-detail/ProductDetail.vue"),//产品详情
}